module.exports = __webpack_public_path__ + "assets/img/25_320.b6512029.jpg";